const SfrInteraction = {
    init() {
        const facetsBar = document.querySelector('.facets__bar');
        const facetsBarWrapper = document.querySelector('.facets__bar-wrapper');
        
        if (facetsBarWrapper && facetsBar) {
            if (window.innerWidth < 640) {
                checkOffsetTop(facetsBarWrapper, facetsBar);
            }
            
            window.addEventListener("scroll", function () {
                checkOffsetTop(facetsBarWrapper, facetsBar);
            });
            
            window.addEventListener("resize", function () {
                checkOffsetTop(facetsBarWrapper, facetsBar);
            });
        }
    }
};

function checkOffsetTop(wrapper, facetsBar) {
    if (window.scrollY > (getOffsetTop(wrapper))) {
        facetsBar.classList.add('fixed');
    } else {
        facetsBar.classList.remove('fixed');
    }
};

const getOffsetTop = element => {
    let offsetTop = 0;
    while(element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
    }
    return offsetTop;
};

window.addEventListener('DOMContentLoaded', () => {
    SfrInteraction.init();
});